import { render } from "./Section.vue?vue&type=template&id=02bf19d8&scoped=true"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"

import "./Section.vue?vue&type=style&index=0&id=02bf19d8&scoped=true&lang=scss"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bf19d8"]])

export default __exports__